import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { SURVEY_COLORS } from "../../shared/theme-constants";

// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styles
interface LearningAnalysisStylesProps {
  isMobile: boolean;
}

export const useLearningAnalysisStyles = makeStyles<Theme, LearningAnalysisStylesProps>(
  (theme) => ({
    loadingContainer: {
      padding: (props) => (props.isMobile ? "16px" : "24px"),
      textAlign: "center",
    },
    container: {
      padding: (props) => (props.isMobile ? "16px" : "24px"),
      [theme.breakpoints.down("sm")]: {
        padding: "16px",
        height: "auto",
        overflowY: "visible",
      },
    },
    headerDescription: {
      fontSize: "16px",
      color: SURVEY_COLORS.TEXT_SECONDARY,
      marginBottom: "16px",
      textAlign: "center",
    },
    contentCard: {
      backgroundColor: SURVEY_COLORS.BACKGROUND_WHITE,
      borderRadius: "8px",
      padding: "24px",
      marginBottom: "16px",
      boxShadow: SURVEY_COLORS.BOX_SHADOW,
      overflowY: "auto",
      overflowX: "hidden",
      maxHeight: (props) => (props.isMobile ? "none" : "calc(90vh - 300px)"),
      [theme.breakpoints.down("sm")]: {
        maxHeight: "none",
        padding: "16px",
      },
    },
    insideHeader: {
      fontSize: "18px",
      fontWeight: 600,
      marginBottom: "20px",
    },
    questionItem: {
      marginBottom: "32px",
      "&:last-child": {
        marginBottom: 0,
      },
    },
    buttonGroup: {
      display: "flex",
      gap: "12px",
      justifyContent: "space-between",
      marginTop: "24px",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        justifyContent: "stretch",
      },
    },
    primaryButton: {
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: 600,
      height: "40px",
      padding: "0 16px",
      backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
      color: SURVEY_COLORS.MODAL_TEXT_WHITE,
      border: "none",
      textTransform: "none",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
      "& .MuiButton-endIcon": {
        marginLeft: "4px",
        "& svg": {
          fontSize: "12px !important",
        },
      },
      "&:hover": {
        backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
        outline: `2px solid ${SURVEY_COLORS.BLACK}`,
      },
      "&.Mui-focusVisible": {
        outline: `2px solid ${SURVEY_COLORS.BLACK}`,
        fontWeight: 700,
        "& .MuiTouchRipple-child": {
          backgroundColor: "transparent",
        },
      },
      "&:disabled": {
        opacity: 0.5,
        backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
        color: SURVEY_COLORS.MODAL_TEXT_WHITE,
      },
    },
    outlineButton: {
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: 600,
      height: "40px",
      padding: "0 16px",
      backgroundColor: "transparent",
      color: SURVEY_COLORS.TEXT_PRIMARY,
      border: `1px solid ${SURVEY_COLORS.BORDER_DEFAULT}`,
      textTransform: "none",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
      "& .MuiButton-startIcon": {
        marginRight: "4px",
        "& svg": {
          fontSize: "12px !important",
        },
      },
      "&:hover": {
        backgroundColor: SURVEY_COLORS.BUTTON_HOVER_BG,
        outline: `2px solid ${SURVEY_COLORS.BLACK}`,
      },
      "&.Mui-focusVisible": {
        outline: `2px solid ${SURVEY_COLORS.BLACK}`,
        fontWeight: 700,
        "& .MuiTouchRipple-child": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
);
